import { ExpandAltOutlined, ShrinkOutlined } from '@ant-design/icons'
import { GraviButton, Horizontal } from '@gravitate-js/excalibrr'
import type { GridApi } from 'ag-grid-community'
import { Tooltip } from 'antd'

type ExpandCollapseButtonsProps = {
  gridAPIRef: React.MutableRefObject<GridApi> | React.RefObject<GridApi>
  expandOverride?: () => void
  collapseOverride?: () => void
  isExpanded: boolean
  setExpanded: (isExpanded: boolean) => void
  type?: 'ghost' | 'solid'
}

export function ExpandCollapseButtons({
  gridAPIRef,
  expandOverride,
  collapseOverride,
  isExpanded,
  setExpanded,
  type,
}: ExpandCollapseButtonsProps) {
  const expandAll = () => {
    if (expandOverride) {
      expandOverride()
    } else {
      setExpanded(true)
      gridAPIRef?.current?.forEachNode((node) => {
        node.setExpanded(true)
      })
    }
  }
  const collapseAll = () => {
    if (collapseOverride) {
      collapseOverride()
    } else {
      setExpanded(false)
      gridAPIRef?.current?.forEachNode((node) => {
        node.setExpanded(false)
      })
    }
  }
  return (
    <Horizontal>
      <Tooltip title={isExpanded ? 'Collapse All' : 'Expand All'}>
        {isExpanded ? (
          <GraviButton
            icon={<ShrinkOutlined />}
            color='primary'
            appearance={type === 'ghost' ? 'link' : 'solid'}
            onClick={collapseAll}
          />
        ) : (
          <GraviButton
            icon={<ExpandAltOutlined />}
            color='primary'
            appearance={type === 'ghost' ? 'link' : 'outlined'}
            onClick={expandAll}
          />
        )}
      </Tooltip>
    </Horizontal>
  )
}
